<template>
  <div class="container type-radio">
    <div class="scroll-x" ref="radio">
      <div class="input-holder">
        <label
          v-for="(item, k) in data.items"
          :key="k"
          :class="{ active: item.key === val }"
          ref="inputs"
        >
          <div class="bg"></div>
          <span>{{ item.label }}</span>
          <img
            :alt="item.key"
            :src="require('@/assets/' + item.key + '.svg')"
            width="162"
            height="123"
            title=""
          />
          <input
            type="radio"
            :name="data.name"
            v-model="val"
            @change="
              changeValue();
              scrollToIndex(k);
            "
            :value="item.key"
          />
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Radio",
  props: ["data", "value"],
  data() {
    return {
      val: this.value
    };
  },
  mounted() {
    // this.val = this.answer;
  },
  methods: {
    changeValue() {
      this.$emit("input", this.val, this.data.name);
    },
    scrollToIndex(index, noanim) {
      const el = this.$refs.inputs[index];
      const parent = this.$refs.radio;
      parent.classList[noanim ? "remove" : "add"]("animscroll");
      const elhalfheight = el.offsetHeight / 2;
      const parhalfheight = parent.offsetHeight / 2;
      const elhalfwidth = el.offsetWidth / 2;
      const parhalfwidth = parent.offsetWidth / 2;

      parent.scrollTop = el.offsetTop + elhalfheight - parhalfheight;
      parent.scrollLeft = el.offsetLeft + elhalfwidth - parhalfwidth;
    }
  }
};
</script>

<style lang="scss">
.type-radio {
  padding-top: 24px;
  .scroll-x {
    width: 100vw;
    height: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    margin-bottom: 16px;
    padding-bottom: 16px;
    &.animscroll {
      scroll-behavior: smooth;
    }
    .input-holder {
      padding: 0 0 0 22px;
      white-space: nowrap;
      height: 100%;
      label {
        img {
          width: 62vw;
          height: auto;
          position: relative;
          z-index: 2;
        }
      }
    }
  }
  .input-holder {
    display: flex;
    width: calc(3 * (62vw + 52px));
    label {
      display: flex;
      flex-direction: column;
      position: relative;
      background: $white;
      box-sizing: border-box;
      border-radius: 22px;
      //border: 1px solid $white;
      min-height: 310px;
      height: 100%;
      // padding: 16px;
      padding: 64px 16px 16px;
      margin: 0 8px;
      //width: 62vw;
      //max-width: 290px;
      text-align: center;
      justify-content: center;
      overflow: hidden;
      //aspect-ratio: 30 / 35;
      transition: all 0.3s ease-in-out;
      /* .bg {
        position: absolute;
        z-index: 1;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: $blue;
        transform: translateX(100%);
        transition: all 0.3s ease-in-out;
        opacity: 0;
      }
      &:before {
        content: "";
        position: absolute;
        z-index: 2;
        right: 0;
        top: 0;
        background: $black;
        width: 76px;
        height: 76px;
        opacity: 0;
        transform: translate(150%, -50%) rotate(45deg);
        transition: all 0.3s ease-in-out;
      }*/
      &:after {
        background: $white;
        border-radius: 50%;
        position: absolute;
        z-index: 2;
        width: 22px;
        height: 22px;
        right: 14px;
        top: 14px;
        content: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDEwIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjUgNC43NTAwOUw0LjQ5OTg5IDcuMDAwMDlMOC41IDEiIHN0cm9rZT0iIzMxNTJGNiIgc3Ryb2tlLXdpZHRoPSIxLjgiLz4KPC9zdmc+Cg==");
        opacity: 0;
        //transform: translateY(100%);
        transition: all 0.3s ease-in-out;
      }
      span {
        position: absolute;
        z-index: 2;
        top: 16px;
        left: 16px;
        font-weight: 600;
        font-size: 16px;
        line-height: 25px;
        color: $black;
        text-align: left;
        text-transform: uppercase;
      }
      input {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        opacity: 0;
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        outline: 0;
      }

      &.active {
        background: $blue;
        span {
          color: $white;
        }
        //border: 1px solid $black;
        /*.bg {
          transform: translateX(0);
          opacity: 1;
        }
        &:before {
          transform: translate(50%, -50%) rotate(45deg);
          opacity: 1;
        }*/
        &:after {
          //transform: translateY(0);
          opacity: 1;
        }
      }
    }
  }
  @media screen and (min-width: $breakpoint) {
    padding-top: 0;
    .scroll-x {
      display: flex;
      align-items: center;
      width: auto;
      overflow: initial;
      white-space: normal;
      margin-bottom: 0;
      .input-holder {
        width: auto;
        white-space: normal;
        min-height: 60%;
        height: auto;
        label {
          min-height: 250px;
          aspect-ratio: 21 / 25;
          img {
            width: auto;
            min-width: 150px;
          }
        }
      }
    }
    .input-holder {
      justify-content: space-between;
      gap: 16px;
      label {
        width: auto;
        padding: 64px 24px 24px;
        margin: 0;
        span {
          left: 24px;
          top: 24px;
          font-size: 15px;
          line-height: 17px;
        }
      }
    }
  }
}
</style>
